import { reverseDDMMYYYY } from "Utils/dateUtils";
import { defaultMaxAge } from "Validation/ninValidation";
import {
  endOfToday,
  isAfter,
  isBefore,
  startOfToday,
  subYears,
} from "date-fns";
import { ChildDateOfBirth } from "./interfaces";

export const isChildBorn = (child: ChildDateOfBirth): boolean => {
  const childBirthDate = new Date(reverseDDMMYYYY(child.dateOfBirth));
  return (
    isBefore(childBirthDate, endOfToday()) &&
    isAfter(childBirthDate, subYears(startOfToday(), defaultMaxAge))
  );
};
